module.exports = __webpack_public_path__ + "static/06-1cab1e204b51ff1fedbf376bef06e919.png";